import axiosInstance from '@/api/index'

export async function createIDTokenCookie(idToken: string): Promise<void> {
  await axiosInstance.post(`/idtoken-cookie`, { value: idToken })
}
